import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { AIService } from '../../../services/ai.service';
import { UserService } from '../../../services/user.service';
import { BusinessService } from '../../../services/business.service';
import { PanelModule } from '../../../modules/panel.module';
import { Constants } from '../../../model/common.model';
import { FileUploadComponent } from '../../file-upload/file-upload.component';
import { UiSettingsComponent } from '../../ui-settings/ui-settings.component';
import { MenuItemOptionComponent } from '../menu-item-option/menu-item-option.component';
import { TagSelectorComponent } from '../tag-selector/tag-selector.component';

@Component({
  selector: 'brt-menu-item-save',
  standalone: true,
  imports: [PanelModule, FileUploadComponent, UiSettingsComponent, MenuItemOptionComponent, TagSelectorComponent],
  templateUrl: './menu-item-save.component.html',
  styleUrl: './menu-item-save.component.scss'
})
export class MenuItemSaveComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  businessId: any;
  menuId: any;
  menuItemId: any;
  menuItem: any;
  business: any;
  constructor(private route: ActivatedRoute, private router: Router, private menuService: MenuService,
    private aiService: AIService, private userService: UserService, private businessService: BusinessService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      this.menuId = params['mid'];
      this.menuItemId = params['id'];
      await this.load();
    });
  }
  orderTypes = Constants.OrderTypes;
  orderSources = Constants.OrderSources;
  weekDays = Constants.WeekDays;

  async load() {
    if (!this.menuItemId)
      this.menuItem = {
        BusinessId: this.businessId,
        MenuIds: this.menuId ? [this.menuId] : [],
        BasePrice: [{ OrderType: 'Default', Price: 0 }],
        ServingHours: [{ OrderType: 'Default', Days: Constants.WeekDays, 'StartTime': '08:00:00', 'EndTime': '22:00:00' }],
        Options: [],
        UI: {}
      };
    else
      this.menuItem = await this.menuService.getMenuItem(this.menuItemId);

    if (!this.menuItem.BasePrice) this.menuItem.BasePrice = [];
    if (!this.menuItem.SourcePrice) this.menuItem.SourcePrice = [];

    const currentBusinessId = this.menuItem.BusinessId || this.businessId;
    if (currentBusinessId && this.business?.Id !== currentBusinessId)
      this.business = await this.businessService.get(currentBusinessId);
  }

  async save(navigate = true) {
    await this.menuService.saveMenuItem(this.menuItem);
    if (navigate) {
      if(window.history?.length) window.history.back()      
      else await this.router.navigate([this.basePath, 'menu', this.businessId, this.menuId, 'item'].filter(_ => _));
    } 
  }

  async onUpload(paths: string[]) {
    this.menuItem.UI.Image = paths[0];
    this.save(false);
  }
}
